import * as THREE from 'three';

const COLOR = 0x2f6fb0; // same blue as the chalk cube (CueStick)
const RADIUS = 0.006; // a small tick, not a big blob

/**
 * Faint chalk-colored dots you can dab onto the cloth (hold F + click) to mark a
 * spot while lining up a shot. Cleared the moment the next shot fires.
 */
export class ChalkMarks {
  readonly group = new THREE.Group();
  private readonly geometry = new THREE.CircleGeometry(RADIUS, 20);
  private readonly material = new THREE.MeshBasicMaterial({
    color: COLOR,
    transparent: true,
    opacity: 0.55,
    depthTest: false,
  });

  /** Dab a mark at table position (x, y). */
  add(x: number, y: number): void {
    const dot = new THREE.Mesh(this.geometry, this.material);
    dot.position.set(x, y, 0.0025); // just above the cloth
    dot.renderOrder = 997;
    this.group.add(dot);
  }

  clear(): void {
    for (const child of [...this.group.children]) this.group.remove(child);
  }

  get count(): number {
    return this.group.children.length;
  }
}
